/* Tailery presentation enhancements. Existing product, cart and checkout handlers are unchanged. */
(() => {
  if (window.taileryRefreshLoaded) return;
  window.taileryRefreshLoaded = true;
  const selector = '.tr-disclosure';
  const close = (details, restoreFocus = false) => {
    details.removeAttribute('open');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) details.querySelector(':scope > summary')?.focus();
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll(`${selector}[open]`).forEach(details => {
      if (!details.contains(event.target) || event.target.closest('nav a')) close(details);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const focused = document.activeElement?.closest(`${selector}[open]`);
    const open = focused || document.querySelector(`${selector}[open]`);
    if (open) { close(open, true); event.preventDefault(); }
  });
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches(selector)) return;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
    if (!details.open) return;
    document.querySelectorAll(`${selector}[open]`).forEach(other => {
      if (other !== details && !other.contains(details) && !details.contains(other)) close(other);
    });
  }, true);
  const initialize = () => {
    document.querySelectorAll(selector).forEach(details => details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open)));
    const header = document.querySelector('.tailery-shared-header');
    if (!header) return;
    const measure = () => document.documentElement.style.setProperty('--header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    measure();
    if ('ResizeObserver' in window && !header.dataset.trObserved) {
      header.dataset.trObserved = 'true';
      new ResizeObserver(measure).observe(header);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true }); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', initialize);
})();
